// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__frame--lfrra {
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  flex: 1;
  overflow: hidden;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__header--KAYfN {
  padding: 2px 0 16px;
  display: flex;
  gap: 16px;
  align-items: center;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__header--KAYfN .src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__title--jtNOa {
  color: rgba(0, 0, 0, 0.85);
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__header--KAYfN .src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__state--EXlHH {
  flex: 1;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__toolbar--lKvGu {
  padding: 16px 0 2px 0;
  display: flex;
  gap: 8px;
  align-items: center;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__toolbar--lKvGu .src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__firstTool--Bcz7C {
  flex: 1;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__tableBox--wRoGO {
  flex: 1;
  overflow: auto;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__tableBox--wRoGO td {
  padding: 8px !important;
}
.src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__ganttSwitchBox--jPmaQ {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsPlanning2/Planning2Control/Planning2Control.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EAEA,eAAA;EACA,OAAA;EACA,gBAAA;AAAF;AAGA;EACE,mBAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AADF;AAHA;EAOI,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AADJ;AAXA;EAeI,OAAA;AADJ;AAKA;EACE,qBAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AAHF;AADA;EAOI,OAAA;AAHJ;AAOA;EACE,OAAA;EACA,cAAA;AALF;AAGA;EAKI,uBAAA;AALJ;AASA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAPF","sourcesContent":[".frame {\n  display: flex;\n  flex-direction: column;\n\n  padding: 0 24px;\n  flex: 1;\n  overflow: hidden;\n}\n\n.header {\n  padding: 2px 0 16px;\n  display: flex;\n  gap: 16px;\n  align-items: center;\n\n  .title {\n    color: rgba(0, 0, 0, 0.85);\n    font-family: Inter;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 120%;\n  }\n  .state {\n    flex: 1;\n  }\n}\n\n.toolbar {\n  padding: 16px 0 2px 0;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n\n  .firstTool {\n    flex: 1;\n  }\n}\n\n.tableBox {\n  flex: 1;\n  overflow: auto;\n\n  td {\n    padding: 8px !important;\n  }\n}\n\n.ganttSwitchBox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__frame--lfrra`,
	"header": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__header--KAYfN`,
	"title": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__title--jtNOa`,
	"state": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__state--EXlHH`,
	"toolbar": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__toolbar--lKvGu`,
	"firstTool": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__firstTool--Bcz7C`,
	"tableBox": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__tableBox--wRoGO`,
	"ganttSwitchBox": `src-businessServices-services-bsPlanning2-Planning2Control-Planning2Control-module__ganttSwitchBox--jPmaQ`
};
export default ___CSS_LOADER_EXPORT___;
